import React, { type FC } from 'react'
import { Link } from 'react-router'
import { routes } from '@mobi/account/Utils'
import { type PaymentMethodsAll } from '@mobi/component-library/Areas/Deposit/types'
import { CustomerServiceCentre, CustomerServiceTelephone } from '@mobi/component-library/Base/Link'
import { InfoBox } from '@mobi/component-library/Feedback/InfoBox'
import { paymentMethodTypeNameMap } from '../Utils/schema'
import { useHostContext } from '../../../Common/HostContext'

type Props = {
  paymentMethod: PaymentMethodsAll
}

export const PaymentMethodBlocked: FC<Props> = ({ paymentMethod }) => {
  return (
    <InfoBox size='md' color={paymentMethod === 'PayID' ? 'red' : 'orange'}>
      <BlockedPaymentMethodText paymentMethod={paymentMethod} />
    </InfoBox>
  )
}

PaymentMethodBlocked.displayName = 'PaymentMethodBlocked'

const BlockedPaymentMethodText: FC<Props> = ({ paymentMethod }) => {
  const { channel } = useHostContext()

  const customerServiceText =
    paymentMethod === 'CreditCard' && channel === 'mobile' ? (
      <>
        Please check your settings on the <Link to={routes.blockDebitCard}>Block Debit Card</Link>{' '}
        page or call us on <CustomerServiceTelephone /> for more information.
      </>
    ) : (
      <CustomerServiceCentre />
    )
  return (
    <div>
      <strong>
        Deposits are not enabled for {paymentMethodTypeNameMap[paymentMethod]} on this account.
        {paymentMethod === 'PayID' &&
          ' Any deposits to this PayID will be automatically refunded to your bank account.'}
      </strong>
      <br />
      {customerServiceText}
    </div>
  )
}
